(function () {
  'use strict';

  function loadDatatables(nbElem) {
    var cssId = 'cssDatatables';
    if (!document.getElementById(cssId)) {
      var head = document.getElementsByTagName('head')[0];
      var link = document.createElement('link');
      link.id = cssId;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = '//cdn.datatables.net/1.10.19/css/jquery.dataTables.min.css';
      link.media = 'all';
      head.appendChild(link);
    }
    $.ajax({
      url: '//cdn.datatables.net/1.10.19/js/jquery.dataTables.min.js',
      dataType: 'script',
      cache: true,
      success: function () {
        processDatatables(nbElem);
      }
    });
  }

  function processDatatables(nbElem) {
    // On veut ordonner par les dimensions
    var countDimensions = $('.dimension-header').length;
    var sortArray = [];

    for (var i = 0; i < countDimensions; i++) {
      sortArray.push([i, 'asc']);
    }

    if (nbElem > 10) {
      $('#elementariesTable').DataTable({ // eslint-disable-line new-cap
        searching: false,
        language: languageFr, // eslint-disable-line no-undef
        order: sortArray
      });
    } else {
      $('#elementariesTable').DataTable({ // eslint-disable-line new-cap
        paging: false,
        searching: false,
        info: false,
        language: languageFr, // eslint-disable-line no-undef
        order: sortArray
      });
    }
  }

  angular
    .module('app.product', ['app.bxslider'])

    /* @ngInject */
    .directive('productDetail', function () {
      return {
        restrict: 'E',
        scope: false,
        bindToController: {
          id: '<idProduct',
          url: '@productUrl',
          idGroup: '<idProductGroup',
          urlGroup: '@productGroupUrl',
          isPrimary: '<',
          allowAddToCart: '<',
          min: '<',
          step: '<',
          designation: '@productDesignation',
          img: '<productImg',
          modalCtrl: '<',
          nbElementaries: '<?',
          keyWebAspect: '@?',
          device: '<'
        },
        controllerAs: 'productCtrl',
        /* @ngInject */
        controller: ["$scope", "$rootScope", "$location", "productService", "AppService", "ModalService", "productsGridService", "$timeout", function ($scope, $rootScope, $location, productService, AppService, ModalService, productsGridService, $timeout) {
          var ctrl = this;

          ctrl.quantity = 1;
          ctrl.costTTC = 0;
          ctrl.costHT = 0;

          ctrl.$onInit = function () {

            ctrl.galleryImgLoader = false;
            ctrl.zoomLoaded = false;

            var productsData = productService.getProduct();
            var product = {
              idProduct: ctrl.id,
              isPrimary: ctrl.isPrimary,
              min: ctrl.min,
              step: ctrl.step,
              designation: ctrl.designation,
              img: ctrl.img
            };
            productService.setProduct(ctrl.idGroup, _.merge(productsData[ctrl.idGroup], product));

            ctrl.addToCartActive = productService.getActive();

            if (ctrl.modalCtrl && ctrl.modalCtrl.quantity) {
              ctrl.modalCtrl.data.id = ctrl.id;
              ctrl.modalCtrl.productsData = ctrl.getProductsToAdd(ctrl.modalCtrl.quantity, ctrl.modalCtrl.quantity);
              ctrl.modalCtrl.addToCartActive = ctrl.addToCartActive;

              var str = ctrl.modalCtrl.data.url.split('-p-')[1];
              var currentAttrs = str.slice(str.indexOf('/'));
              if (currentAttrs === ctrl.modalCtrl.updateFromCart) {
                ctrl.modalCtrl.addToCartActive = false;
              }
            } else if (ctrl.modalCtrl && !ctrl.attributes) {
              ctrl.modalCtrl.productsData = ctrl.getProductsToAdd(1, 1);
            }

            AppService.getParams()
              .then(function (params) {
                ctrl.showTTCPrice = params.Visitor.CardType.ShowTTCPrice;
                ctrl.showEcoContribution = true;
              })
              .catch(function (error) {
                console.error(error);
              });

            var reload = false;
            $timeout(function () {
              productsGridService.resizeGrid('productsGrid', ctrl.device.size, !reload);

              if (ctrl.keyWebAspect === 'WADimensionTableau' && ctrl.nbElementaries > 0) {
                if (angular.isUndefined($.fn.DataTable)) {
                  loadDatatables(ctrl.nbElementaries);
                } else {
                  $timeout(function () {
                    processDatatables(ctrl.nbElementaries);
                  });
                }
              }

              $rootScope.$emit('lazyImg:refresh');
            });
          };

          //
          $scope.$on('updateProduct', function () {
            ctrl.addToCartActive = productService.getActive();
          });

          $scope.$on('updateNbReviews', function (event, value) {
            ctrl.nbReviews = value;
          });

          // Functions

          ctrl.setPricesData = function (prices, eco) {
            ctrl.prices = prices;
            ctrl.eco = eco;
            ctrl.setPrice(ctrl.quantity);
          };

          ctrl.setPrice = function (qty) {
            var productData = productService.getProduct()[ctrl.idGroup];
            ctrl.costHT = 0;
            ctrl.costTTC = 0;

            _.each(productData.elements, function (component) {
              ctrl.costHT += component.costHT || 0;
              ctrl.costTTC += component.costTTC || 0;
            });

            _.each(ctrl.prices, function (price) {
              if (_.inRange(qty, price.range[0], price.range[1] || 10000)) {
                ctrl.Price = price;
                ctrl.Price.EcoContribution = ctrl.eco;
                productService.setProductPrice(ctrl.idGroup, ctrl.Price, ctrl.costTTC, ctrl.costHT, ctrl.showTTCPrice, ctrl.prices);
                return false;
              }
            });
          };

          ctrl.initZoom = function () {
            if (!ctrl.galleryZoomInit) {
              ctrl.galleryZoomInit = true;
              $scope.$broadcast('initZoom');
            }
          };

          /* changement de dimensions */
          ctrl.changeAttribute = function () {
            var url = ctrl.urlGroup;
            _.each(ctrl.attributes, function (attribute) {
              url = attribute === '' ? url : url + '/' + attribute;
            });

            if (ctrl.modalCtrl) {
              ctrl.modalCtrl.productsData = ctrl.getProductsToAdd(ctrl.modalCtrl.quantity, ctrl.modalCtrl.quantity);
              $scope.modalCtrl.showLoader = true;
              $scope.modalCtrl.data.url = url;

              var $body = $('.modal-quick-view .modal-body');
              $body.css({ 'height': $body.height() + 'px' });
            } else {
              $location.path(url).replace();
            }
          };

          /* modification input quantity */
          ctrl.setInputQuantity = function (qty) {
            ctrl.quantity = qty || 1;
            ctrl.setPrice(qty);
          };

          ctrl.setCustomization = function (model, tooltip) {
            var btnEnabled = true,
              selected;
            ctrl.costTTC = 0;
            ctrl.costHT = 0;
            _.each(model.Items, function (item) {
              if (!item.Group) {
                if (item.Field.Value && item.Field.Value !== '') {
                  ctrl.costTTC += item.Field.AdditionalCostTTC;
                  ctrl.costHT += item.Field.AdditionalCostHT;
                  if (item.Field.CustomizationType === 3) {
                    selected = _.find(item.Field.Items, { 'IDCustomizationListItem': parseInt(item.Field.Value) });
                    ctrl.costTTC += selected.AdditionalCostTTC;
                    ctrl.costHT += selected.AdditionalCostHT;
                  }
                } else if (item.Field.Required) {
                  btnEnabled = false;
                }
              }
              if (item.Group) {
                _.each(item.Group.Fields, function (field) {
                  if (field.Value && field.Value !== '') {
                    ctrl.costTTC += field.AdditionalCostTTC;
                    ctrl.costHT += field.AdditionalCostHT;
                    if (field.CustomizationType === 3) {
                      selected = _.find(field.Items, { 'IDCustomizationListItem': parseInt(field.Value) });
                      ctrl.costTTC += selected.AdditionalCostTTC;
                      ctrl.costHT += selected.AdditionalCostHT;
                    }
                  } else if (field.Required) {
                    btnEnabled = false;
                  }
                });
              }
            });
            ctrl.setPrice(ctrl.quantity);
            if (!btnEnabled) {
              $scope.$broadcast('updateTooltip', tooltip);
              ctrl.addToCartActive = false;
            } else {
              $scope.$broadcast('updateTooltip');
              ctrl.addToCartActive = true;
            }
            if (!ctrl.allowAddToCart) {
              ctrl.addToCartActive = false;
            }
            productService.setProductCustomization(ctrl.idGroup, model);
            $scope.$broadcast('updateComment', productService.getProduct()[ctrl.idGroup].Comment);
          };

          /* ajout panier */
          ctrl.setQuantity = function (inc) {
            ctrl.quantity = inc;
            productService.setProductQuantity(ctrl.idGroup, inc);
          };
          ctrl.getProductsToAdd = function (qty, inc) {
            ctrl.quantity = qty;
            ctrl.setPrice(qty);
            ctrl.setQuantity(inc);
            return productService.getProductsData();
          };

          ctrl.setActiveTab = function (nb) {
            ctrl.active = nb;
          };

          ctrl.giftlist = function (logged) {
            console.info({ giftlist_logged: logged, id: ctrl.id });
          };

          ctrl.openCmsLoyalty = function () {
            ModalService.show(
              '/Template/Modal/ModalCms',
              {
                url: '/page-cms/programme-fidelite'
              },
              'lg',
              null,
              null,
              null,
              {
                modalTitle: 'Points fidélité',
                modalAutoScroll: false
              }
            );
          };

          ctrl.openModalReviews = function (id) {
            ModalService.show(
              '/Template/Product/ModalReviews',
              {
                id: id
              },
              null,
              'modalReviewsCtrl'
            );
          };

          ctrl.openModalQuickAddDimensions = function (id, designation) {
            ModalService.show(
              '/quick-add-dimensions/' + id + '?' + (new Date().getTime()),
              {
                designation: designation,
                nbElementaries: ctrl.nbElementaries
              },
              'xl',
              'modalQuickAddDimensionsCtrl',
              null,
              ctrl.device
            );
          };
        }]
      };
    })

    /* @ngInject */
    .controller('modalQuestionCtrl', ["data", "device", "options", "HttpService", "AppService", "ModalService", "toastr", function (data, device, options, HttpService, AppService, ModalService, toastr) {
      var ctrl = this;

      ctrl.data = data;

      var messageTitle;

      ctrl.successMessage = function (title) {
        messageTitle = title;
      };

      AppService.getParams()
        .then(function (params) {
          if (params.IsLogged) {
            ctrl.data.Email = params.Visitor.Email;
            ctrl.data.FirstName = params.Visitor.FirstName;
            ctrl.data.LastName = params.Visitor.LastName;
          }
        })
        .catch(function (error) {
          console.error(error);
        });

      ctrl.submit = function () {
        ctrl.loading = true;

        HttpService.post({
          url: '/Product/QuestionProduct',
          data: ctrl.data
        })
          .then(function (response) {
            AppService.getTranslate()
              .then(function (translate) {
                if (response.status === 'OK') {
                  ModalService.close();
                  toastr.success('', messageTitle, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                } else {
                  toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                }
                ctrl.loading = false;
              })
              .catch(function (error) {
                console.error(error);
              });
          })
          .catch(function (error) {
            console.error(error);
          });
      };
    }])

    /* @ngInject */
    .controller('modalSendToAFriendCtrl', ["data", "device", "options", "HttpService", "AppService", "ModalService", "toastr", function (data, device, options, HttpService, AppService, ModalService, toastr) {
      var ctrl = this;

      ctrl.data = data;

      AppService.getParams()
        .then(function (params) {
          if (params.IsLogged) {
            ctrl.data.FirstName = params.Visitor.FirstName;
            ctrl.data.Email = params.Visitor.Email;
          }
        })
        .catch(function (error) {
          console.error(error);
        });

      ctrl.submit = function () {
        ctrl.loading = true;

        HttpService.post({
          url: '/Product/SendToAFriend',
          data: ctrl.data
        })
          .then(function (response) {
            AppService.getTranslate()
              .then(function (translate) {
                if (response.status === 'OK') {
                  ModalService.close();
                  toastr.success('', translate.messages.MessageSent, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                } else {
                  toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                }
                ctrl.loading = false;
              })
              .catch(function (error) {
                console.error(error);
              });
          })
          .catch(function (error) {
            console.error(error);
          });
      };

    }])

    /* @ngInject */
    .controller('modalAvailabilityAlertCtrl', ["data", "device", "options", "ModalService", "AppService", "HttpService", "toastr", function (data, device, options, ModalService, AppService, HttpService, toastr) {
      var ctrl = this;
      ctrl.data = data;
      ctrl.data.Email = '';

      var messageTitle,
        messageText;

      ctrl.successMessage = function (title, text) {
        messageTitle = title;
        messageText = text;
      };

      ctrl.submit = function () {
        ctrl.loading = true;
        HttpService.post({
          url: '/Product/AvailabilityAlert',
          data: ctrl.data
        })
          .then(function (response) {
            ctrl.loading = false;
            if (response.status === 'OK') {
              ModalService.close();
              toastr.success(messageText, messageTitle, {
                allowHtml: true,
                extraData: {
                  template: 'toast_message.tpl'
                }
              });
            } else {
              AppService.getTranslate()
                .then(function (translate) {
                  toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                })
                .catch(function (error) {
                  console.error(error);
                });
            }
          })
          .catch(function (error) {
            console.error(error);
          });
      };

    }])

    /* @ngInject */
    .controller('modalQuickAddDimensionsCtrl', ["data", "device", "options", "$scope", "$timeout", function (data, device, options, $scope, $timeout) {
      var ctrl = this;

      ctrl.data = data;
      ctrl.device = device;

      ctrl.$onInit = function () {
        if (ctrl.data.nbElementaries > 0) {
          if (angular.isUndefined($.fn.DataTable)) {
            loadDatatables(ctrl.data.nbElementaries);
          } else {
            $timeout(function () {
              processDatatables(ctrl.data.nbElementaries);
            });
          }
        }
      };
    }])

    /* @ngInject */
    .controller('modalReviewsCtrl', ["data", "device", "options", "HttpService", function (data, device, options, HttpService) {
      var ctrl = this;
      ctrl.data = data;

      ctrl.showLoader = true;

      HttpService.get({
        url: '/Reviews/' + ctrl.data.id + '/0/100/RateDESC/0',
        cache: false
      })
        .then(function (response) {
          ctrl.data = response;
          ctrl.showLoader = false;
        })
        .catch(function (error) {
          console.error(error);
        });

    }])

    /* @ngInject */
    .controller('modalQuickViewCtrl', ["data", "device", "options", "$scope", function (data, device, options, $scope) {
      var ctrl = this;
      ctrl.data = data;
      ctrl.device = device;
      ctrl.options = options;
      ctrl.showLoader = true;
      $scope.device = device;

      ctrl.onLoad = function () {
        ctrl.showLoader = false;
        setTimeout(function () {
          $('.modal-quick-view .modal-body').removeAttr('style');
        });
      };
    }]);

})();
